<!-- <section class="banner-shopify">
    <div class="container">
        <div class="title-bar">
            <h1>Shopify E-Commerce Experts in Dubai</h1>
            <p>Pro Web is your trusted Shopify agency in Dubai, providing expert solutions for businesses across the UAE. Whether launching a new online store, migrating to Shopify, or optimizing an existing e-commerce business, we offer customized Shopify services to help you succeed.</p>
            <img src="assets/img/shopify/shopify-img.png"/>
        </div>
    </div>
</section> -->
<app-anim-banner
  heading="Shopify E-Commerce Experts in Dubai"
  description="Pro Web is your trusted Shopify agency in Dubai, providing expert solutions for businesses across the UAE. Whether launching a new online store, migrating to Shopify, or optimizing an existing e-commerce business, we offer customized Shopify services to help you succeed."
  image="shopify-img.png"
></app-anim-banner>
<section class="Hire-Pro-Web-shopify">
    <div class="container">
        <div class="section-shopify">
            <div class="row px-0 align-items-center">
                <div class="col-sm-6">
                    <div class="content-shopify">
                        <h2>Hire Pro Web – Leading Shopify Agency in the UAE </h2>
                        <p>Hire Pro Web to bring your eCommerce vision to life with precision and purpose. As a trusted Shopify agency based in the UAE, we specialize in building customized, high-performance Shopify stores that drive results. Our team has worked with a wide range of clients, from emerging businesses to well-established brands, delivering solutions that are both user-friendly and conversion-focused. With deep platform knowledge and a strategic mindset, we don’t just build stores — we help brands grow. Whether you need a fresh Shopify setup, a redesign, or expert support to scale your online presence, our consultative approach ensures your store reflects your brand and meets your business goals.Hire us for expert guidance, seamless execution, and Shopify solutions that set you apart in a competitive market.</p>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="img-shopify">
                        <a href="">
                            <img src="assets/img/shopify/right-imgage.png"/>
                        </a>
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="shopify-array">
    <div class="container">
        <div class="shopify-agency-page">
                <h2>Why We Are Your Go-To Shopify Agency?</h2>
                <ul class="lidting">
                    <li>
                        <div class="listshop">
                            <svg width="51" height="50" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M36.125 6.95387C32.9993 5.18127 29.3705 4.16675 25.5 4.16675C13.7639 4.16675 4.25 13.4941 4.25 25.0001C4.25 36.5059 13.7639 45.8334 25.5 45.8334C37.2359 45.8334 46.75 36.5059 46.75 25.0001C46.75 23.5732 46.6036 22.1797 46.325 20.8334" stroke="#37CA55" stroke-width="3.1875" stroke-linecap="round"/>
                                <path d="M17 26.0417C17 26.0417 20.1875 26.0417 24.4375 33.3334C24.4375 33.3334 36.25 14.2362 46.75 10.4167" stroke="#37CA55" stroke-width="3.1875" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <p>Successfully delivered 20+ Shopify websites across diverse industries.</p>
                        </div>
                    </li>
                     <li>
                        <div class="listshop">
                            <svg width="51" height="50" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M36.125 6.95387C32.9993 5.18127 29.3705 4.16675 25.5 4.16675C13.7639 4.16675 4.25 13.4941 4.25 25.0001C4.25 36.5059 13.7639 45.8334 25.5 45.8334C37.2359 45.8334 46.75 36.5059 46.75 25.0001C46.75 23.5732 46.6036 22.1797 46.325 20.8334" stroke="#37CA55" stroke-width="3.1875" stroke-linecap="round"/>
                                <path d="M17 26.0417C17 26.0417 20.1875 26.0417 24.4375 33.3334C24.4375 33.3334 36.25 14.2362 46.75 10.4167" stroke="#37CA55" stroke-width="3.1875" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <p>Extensive experience with Shopify Plus implementations for high-growth businesses.  </p>
                        </div>
                    </li>
                     <li>
                        <div class="listshop">
                            <svg width="51" height="50" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M36.125 6.95387C32.9993 5.18127 29.3705 4.16675 25.5 4.16675C13.7639 4.16675 4.25 13.4941 4.25 25.0001C4.25 36.5059 13.7639 45.8334 25.5 45.8334C37.2359 45.8334 46.75 36.5059 46.75 25.0001C46.75 23.5732 46.6036 22.1797 46.325 20.8334" stroke="#37CA55" stroke-width="3.1875" stroke-linecap="round"/>
                                <path d="M17 26.0417C17 26.0417 20.1875 26.0417 24.4375 33.3334C24.4375 33.3334 36.25 14.2362 46.75 10.4167" stroke="#37CA55" stroke-width="3.1875" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <p>A skilled team of 50+ specialists spanning strategy, UI/UX, development, digital marketing, and support.</p>
                        </div>
                    </li>
                </ul>
        </div>
    </div>
</section>

<section class="session-shopify">
    <div class="container">
        <div class="session-title">
            <h2>Businesses We Work With</h2>
            <p>At Pro Web, we partner with forward-thinking brands that view eCommerce as a core driver of growth. From rising startups to established industry leaders, our clients span the retail, lifestyle, automotive, beauty, and technology sectors. They chose us for our deep Shopify expertise, strategic mindset, and ability to deliver solutions that balance creativity with performance. Explore our portfolio to see how we’ve helped brands elevate their online presence and achieve real business impact.</p>

        </div>
        <div class="row">
              <div class="col-sm-6">
                <div class="bussiness-card">
                    <div class="buss-img-card">
                        <div class="hovercard">
                            <img src="/assets/img/servicesdev/audilogo.png" />
                        </div>
                        <img src="/assets/img/shopify/audi.jpg"/>
                    </div>
                    <div class="business-content">
                        <h3>Audi</h3>
                        <p>High-end Shopify storefront with ongoing support tailored for Audi's Middle East market.</p>
                         <a href="/case-study/audi" class="casestydy">View case study</a>
                    </div>
                </div>
            </div>
              <div class="col-sm-6">
                <div class="bussiness-card">
                    <div class="buss-img-card">
                        <div class="hovercard">
                            <img src="/assets/img/servicesdev/bmwlog.png" />
                        </div>
                        <img src="/assets/img/shopify/bmw.png"/>
                    </div>
                    <div class="business-content">
                        <h3>BMW</h3>
                        <p>Built a sleek, interactive Shopify store for BMW's Kuwait division.</p>
                         <a href="/case-study/bmw" class="casestydy">View case study</a>
                    </div>
                </div>
            </div>
          
            <div class="col-sm-6">
                <div class="bussiness-card">
                    <div class="buss-img-card">
                        <div class="hovercard">
                            <img src="/assets/img/servicesdev/kashka.png" />
                        </div>
                        <img src="/assets/img/shopify/kashkha.png" style="    object-position: top;"/>
                    </div>
                    <div class="business-content">
                        <h3>Kashkha</h3>
                        <p>Dynamic customer feedback system with continuous site optimization</p>
                        <a href="/case-study" class="casestydy">View case study</a>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="bussiness-card">
                    <div class="buss-img-card">
                        <div class="hovercard">
                            <img src="/assets/img/servicesdev/levantiques-logo.webp" />
                        </div>
                        <img src="/assets/img/shopify/levantiquess.jpg" style="    object-position: bottom;"/>
                    </div>
                    <div class="business-content">
                        <h3>Levantiques</h3>
                        <p>Premium eCommerce makeover focused on aesthetics, functionality, and user engagement.</p>
                         <a href="/case-study" class="casestydy">View case study</a>
                    </div>
                </div>
            </div>
          
        </div>
        <a href="/case-study" class="btn btn-primary d-block casetybtn mt-3">View All Case Studies</a>
   
    </div>
</section>

<section class="featuredsction">
    <div class="container">
        <div class="session-title">
            <h2>Dubai’s Trusted Team for Shopify & Shopify Plus Development </h2>
            <p>Our team ensures a smooth setup, customization, and ongoing support. From creating visually appealing stores to integrating advanced functionalities, we help businesses maximize their Shopify potential with efficiency and precision.</p>
        </div>
    </div>
    <div class="featured-section-card">
        <div class="container">
            <div class="customrow">
                <div class="col-grid-4">
                    <div class="featured-cards">
                        <div class="titl-bar">
                            <img src="/assets/img/shopify/f1.png"/>
                            <span>Shopify Store Setup & Configuration</span>
                        </div>
                        <p>A successful Shopify store requires more than just selecting a theme—it demands a structured setup with precise configurations to ensure scalability and performance. Our Shopify experts handle end-to-end store setup, including domain configuration, payment gateway integration, tax and shipping rules, product catalog structuring, and custom checkout optimization. We implement advanced Shopify features such as metafields, Shopify Scripts, and Shopify Flow for automation, ensuring a seamless and conversion-optimized shopping experience.</p>
                    </div>
                </div>
                <div class="col-grid-4">
                    <div class="featured-cards">
                        <div class="titl-bar">
                            <img src="/assets/img/shopify/f2.png"/>
                            <span>Shopify Private App / Plugin Development</span>
                        </div>
                        <p>We develop custom private apps and plugins for businesses requiring solutions beyond Shopify’s default capabilities. These bespoke applications integrate directly with your Shopify store via Shopify’s Admin API and Storefront API, allowing for enhanced functionalities such as advanced order management, inventory synchronization, and third-party system integrations. Private apps are designed exclusively for internal use, ensuring optimal security, performance, and compliance with Shopify’s ecosystem.</p>
                    </div>
                </div>
                <div class="col-grid-4">
                    <div class="featured-cards">
                        <div class="titl-bar">
                            <img src="/assets/img/shopify/f3.png"/>
                            <span>Shopify Public App / Plugin Development</span>
                        </div>
                        <p>We specialize in building scalable public Shopify apps for distribution through the Shopify App Store. Our development follows Shopify’s Polaris design system and GraphQL API standards, ensuring seamless compatibility with Shopify’s multi-tenant architecture. Whether it’s marketing automation, analytics, or payment processing, our public apps enhance Shopify’s native capabilities while adhering to Shopify’s security, performance, and compliance guidelines.</p>
                    </div>
                </div>
                <div class="col-grid-4">
                    <div class="featured-cards">
                        <div class="titl-bar">
                            <img src="/assets/img/shopify/f4.png"/>
                            <span>Shopify API Integration</span>
                        </div>
                        <p>Integrating Shopify with external platforms enhances operational efficiency and automates workflows. We provide custom Shopify API integrations, connecting your store with ERP systems, CRM software, payment gateways, logistics providers, and marketing automation tools. Utilizing Shopify’s REST and GraphQL APIs, we ensure data synchronization in real-time, enabling businesses to streamline inventory management, customer segmentation, and order fulfillment processes with maximum accuracy.</p>
                    </div>
                </div>
                <div class="col-grid-4">
                    <div class="featured-cards">
                        <div class="titl-bar">
                            <img src="/assets/img/shopify/f5.png"/>
                            <span>Performance / Speed Optimization</span>
                        </div>
                        <p>Optimizing your Shopify store’s performance is critical for user experience and SEO rankings. To enhance site speed, we leverage best practices such as liquid code optimization, lazy loading, JavaScript deferral, and asset minification. We reduce latency and improve page load times by implementing a global Content Delivery Network (CDN) and optimizing Liquid templates. Our team also conducts Core Web Vitals analysis and performance audits to ensure compliance with Google’s latest page experience standards.</p>
                    </div>
                </div>
                <div class="col-grid-4">
                    <div class="featured-cards">
                        <div class="titl-bar">
                            <img src="/assets/img/shopify/f6.png"/>
                            <span>Shopify Plus Development</span>
                        </div>
                        <p>Enterprise businesses require a robust, scalable infrastructure, and Shopify Plus provides the advanced tools needed for high-growth brands. Our Shopify Plus development services include headless commerce implementation using Hydrogen and Oxygen, custom checkout scripting via Shopify Scripts, and workflow automation through Shopify Flow. We also enable internationalization with multi-store setups, advanced B2B features, and API rate-limit optimizations to handle high-volume transactions efficiently.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
        
   
</section>

<section class="Hire-Pro-Web-shopify padding-b">
    <div class="container">
        <div class="section-shopify">
            <div class="row px-0 ">
                <div class="col-sm-5">
                    <div class="content-shopify pt-70 ">
                        <h2>Build a Future-Ready Business with Shopify</h2>
                        <p>Building a sustainable business requires a platform that adapts to your evolving needs. Shopify’s comprehensive suite of tools enables you to manage your store efficiently while maintaining flexibility. Leverage insights, enhance customer experience, and capitalize on emerging trends with a solution that keeps your business agile and future-focused.</p>
                    </div>
                </div>
                <div class="col-sm-7">
                    <div class="img-shopify">                     
                         <div class="empower_wrapper">
                            <div>
                                 <img src="assets/img/shopify/animationlbockimg.png"/>
                            </div>

                            <div class="emplower_gif">
                                <img
                                src="../../assets/img/servicesdev/react-native/cost-saving.gif"
                                alt=""
                                srcset=""
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="setps-section">    
    <div class="container">
        <div class="section-shopify">
            <div class="row px-0 align-items-center">
                <div class="col-sm-6">
                    <div class="img-shopify">
                        <img src="assets/img/servicesdev/flutter/rocket.gif"/>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="content-shopify">
                        <h2>How We Leverage Shopify for Successful E-Commerce Projects</h2>
                        <p>We implement Shopify through a structured process that includes in-depth analysis, customized configuration, advanced feature integration, and continuous optimization. From store setup to deployment, we ensure a scalable, secure, high-performing e-commerce platform for your business needs.</p>
                    </div>
                </div>
               
            </div>
        </div>
        <div class="setps-container">
            <div class="custom">
                <img src="/assets/img/shopify/line.png" class="line"/>
                <div class="setps-cards activecard" >
                    <span class="setps-circle ">1</span>
                    <span class="setptitle">Understanding Business Needs</span>
                    <ul>
                        <li>Meet with the client to discuss business goals, target customers, and expectations.</li>
                        <li>Identify key features, design preferences, and any special requirements.</li>
                        <li>Outline the project timeline and deliverables.</li>
                    </ul>
                </div>
                <div class="setps-cards">
                    <span class="setps-circle">2</span>
                    <span class="setptitle">Research & Strategy</span>
                    <ul>
                        <li>Study competitors and industry trends to develop a strong approach.</li>
                        <li>Plan the store’s layout, structure, and customer journey.</li>
                        <li>Create a roadmap for design, setup, and launch.</li>
                    </ul>
                </div>
                <div class="setps-cards">
                    <span class="setps-circle">3</span>
                    <span class="setptitle">Store Design & Layout</span>
                    <ul>
                        <li>Develop a store layout that is visually appealing and easy to navigate.</li>
                        <li>Ensure the design reflects the brand’s identity and enhances customer experience.</li>
                        <li>Gather feedback and make necessary adjustments before moving forward.</li>
                    </ul>
                </div>
                <div class="setps-cards">
                    <span class="setps-circle">4</span>
                    <span class="setptitle">Store Setup & Customization</span>
                    <ul>
                        <li>Set up the store with necessary features like product pages, payment options, and shipping methods.</li>
                        <li>Add tools that enhance customer experience, such as search filters or chat support.</li>
                        <li>Ensure the store is mobile-friendly and loads quickly.</li>
                    </ul>
                </div>
                 <div class="setps-cards mobilecard">
                    <span class="setps-circle">5</span>
                    <span class="setptitle">Adding Products & Content</span>
                    <ul>
                        <li>Upload product details, including images, descriptions, and pricing.</li>
                        <li>Organize products into clear categories to make browsing easy.</li>
                        <li>Add important pages like About Us, Contact, and FAQs.</li>
                    </ul>
                </div>
                <div class="setps-cards mobilecard">
                    <span class="setps-circle">6</span>
                    <span class="setptitle">Testing & Refinements</span>
                    <ul>
                        <li>Check the entire shopping process from browsing to checkout.</li>
                        <li>Ensure all links, buttons, and features work correctly.</li>
                        <li>Make any necessary improvements before launching.</li>
                    </ul>
                </div>
               
                <div class="setps-cards mobilecard">
                    <span class="setps-circle">7</span>
                    <span class="setptitle">Store Launch</span>
                    <ul>
                        <li>Final review to ensure everything is in place.</li>
                        <li>Connect the store to its official website domain.</li>
                        <li>Monitor the store after launch to fix any issues quickly.</li>
                    </ul>
                </div>               
               
                <div class="setps-cards mobilecard">
                    <span class="setps-circle">8</span>
                    <span class="setptitle">Ongoing Support & Growth</span>
                    <ul>
                        <li>Provide ongoing support for updates or improvements.</li>
                        <li>Track customer activity and store performance to optimize for better results.</li>
                        <li>Assist with marketing strategies to attract and retain customers.</li>
                    </ul>
                </div>
              
                
                <div class="setps-cards desktopcard">
                    <span class="setps-circle">8</span>
                    <span class="setptitle">Ongoing Support & Growth</span>
                    <ul>
                        <li>Provide ongoing support for updates or improvements.</li>
                        <li>Track customer activity and store performance to optimize for better results.</li>
                        <li>Assist with marketing strategies to attract and retain customers.</li>
                    </ul>
                </div>
                <div class="setps-cards desktopcard">
                    <span class="setps-circle">7</span>
                    <span class="setptitle">Store Launch</span>
                    <ul>
                        <li>Final review to ensure everything is in place.</li>
                        <li>Connect the store to its official website domain.</li>
                        <li>Monitor the store after launch to fix any issues quickly.</li>
                    </ul>
                </div>               
               
                <div class="setps-cards desktopcard">
                    <span class="setps-circle">6</span>
                    <span class="setptitle">Testing & Refinements</span>
                    <ul>
                        <li>Check the entire shopping process from browsing to checkout.</li>
                        <li>Ensure all links, buttons, and features work correctly.</li>
                        <li>Make any necessary improvements before launching.</li>
                    </ul>
                </div>
                <div class="setps-cards desktopcard">
                    <span class="setps-circle">5</span>
                    <span class="setptitle">Adding Products & Content</span>
                    <ul>
                        <li>Upload product details, including images, descriptions, and pricing.</li>
                        <li>Organize products into clear categories to make browsing easy.</li>
                        <li>Add important pages like About Us, Contact, and FAQs.</li>
                    </ul>
                </div>
             
            </div>
        </div>
    </div>
</section>
<section class="tabelcontainer">
    <div class="container">
          <div class="session-title">
            <h2>Shopify vs. Shopify Plus</h2>
           
        </div>
        <div class="tableContent">
            
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col" class="comonhead fw-bold oragetext">Features</th>
                      
                        <th scope="col" class="comonhead bluebg" style="position: relative;"> <img
                                src="./assets/img/shopify/shopify1.png" class="goldbadge" alt=""> </th>
                        <th scope="col" class="comonhead bluebg"><img
                                src="./assets/img/shopify/shopifyplus.png" class="goldbadge" alt=""></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="gray">
                        <td>Customizable Themes</td>
                      
                        <td class="text-center"><svg width="42" height="32" viewBox="0 0 42 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 16.8L15.3333 28L38 4" stroke="#198759" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </td>
                        <td class="text-center"><svg width="42" height="32" viewBox="0 0 42 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 16.8L15.3333 28L38 4" stroke="#198759" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </td>
                      
                    </tr>

                    <tr class="gray">
                        <td>Unlimited Products</td>
                     
                        <td class="text-center"><svg width="42" height="32" viewBox="0 0 42 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 16.8L15.3333 28L38 4" stroke="#198759" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </td>
                        <td class="text-center"><svg width="42" height="32" viewBox="0 0 42 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 16.8L15.3333 28L38 4" stroke="#198759" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </td>
                    </tr>

                    <tr class="white">
                        <td>Advanced API Access</td>
                       
                        <td class="text-center"> <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M49.0847 12.917L12.918 49.0837M12.918 12.917L49.0847 49.0837" stroke="#FF4B4B" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </td>
                         <td class="text-center"><svg width="42" height="32" viewBox="0 0 42 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 16.8L15.3333 28L38 4" stroke="#198759" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </td>
                    </tr>

                      <tr class="white">
                        <td>Automation & Workflows</td>
                       
                        <td class="text-center"> <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M49.0847 12.917L12.918 49.0837M12.918 12.917L49.0847 49.0837" stroke="#FF4B4B" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </td>
                         <td class="text-center"><svg width="42" height="32" viewBox="0 0 42 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 16.8L15.3333 28L38 4" stroke="#198759" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </td>
                    </tr>

                      <tr class="white">
                        <td>Dedicated Account Manager</td>
                       
                        <td class="text-center"> <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M49.0847 12.917L12.918 49.0837M12.918 12.917L49.0847 49.0837" stroke="#FF4B4B" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </td>
                         <td class="text-center"><svg width="42" height="32" viewBox="0 0 42 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 16.8L15.3333 28L38 4" stroke="#198759" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </td>
                    </tr>

                    <tr class="white">
                        <td>Multi-Store Management</td>
                       
                        <td class="text-center"> <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M49.0847 12.917L12.918 49.0837M12.918 12.917L49.0847 49.0837" stroke="#FF4B4B" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </td>
                         <td class="text-center"><svg width="42" height="32" viewBox="0 0 42 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 16.8L15.3333 28L38 4" stroke="#198759" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </td>
                    </tr>

                    
                   

                </tbody>
            </table>
        </div>
    </div>
</section>
<section class="Hire-Pro-Web-shopify">
    <div class="container">
        <div class="section-shopify">
            <div class="row px-0 align-items-center">
                <div class="col-sm-6">
                    <div class="content-shopify">
                        <h2>Why Choose Pro Web for Shopify Development?</h2>
                        <p>At Pro Web, we specialize in creating high-performance Shopify stores that drive sales and enhance user experience. Our Shopify development, customization, and optimization expertise ensures that your e-commerce business stands out in a competitive market. Whether you need a custom-built store, seamless migration, or ongoing maintenance, we offer customized solutions to match your business goals. With a focus on speed, functionality, and design, we create Shopify stores that are visually appealing, mobile-friendly, and conversion-driven. Our team stays updated with the latest Shopify trends and integrations, ensuring your store remains ahead of the curve. Partner with Pro Web for expert Shopify development and unlock the full potential of your online business.</p>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="img-shopify">
                        <img src="assets/img/shopify/dveloperimg.png"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-testimonial-service profile="saifkhan.png" clientname="Mr. Saif A Khan"
    designation="Digital Retail and Customer  Applications Manager- Audi" location="United Arab Emirates" flag="uaeflog.png"
    clientcomment="Rohit has been very hands on and proactive with stake holder management, he is very approachable and always ensures clarity in user’s requirements. Rohit and his team has been supporting us in our pilot projects using Shopify platform and have delivered some amazing results."
    rating="Rated 4.9 out of 5.0" [clientimg]="data" 
    clienttarget="audilogo.png"></app-testimonial-service>


<section class="spacing">
    <div class="container-md">
        <div class="row  justify-content-center">
            <h2>Frequently Asked Questions </h2>
            <p class="my-3">Find the answers you need to know more about Shopify</p>
           

            <div class="rowrr my-4">
                <div class="fwqq">
                    <div class="faq-list faq-cutom" *ngFor="let item of faq; let i = index">
                        <div class="faq-title d-flex justify-content-between " (click)="toggleAccordian($event, i)">
                            <h6>{{item.title}}</h6>
                            <!-- <span class="arrow" [ngClass]="{'up': item.isActive}"></span> -->

                            <h4 *ngIf="item.isActive == false"> + </h4>
                            <h4 *ngIf="item.isActive == true"> - </h4>
                        </div>
                        <div class="faq-des" *ngIf="item.isActive">
                            <div [innerHTML]="item.des"></div>
                        </div>
                    </div>
                </div>

             
            </div>

        </div>
    </div>

</section>

<!-- <section class="banner-bttom-sec">
    <div class="container">
        <div class="row">
            <div class="col-sm-6">
                <div class="mobilecard">
                     <img src="/assets/img/shopify/shopifybottombanner.jpg"/>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="bottomrightcontent">
                    <h3>Your Trusted Shopify E-commerce Experts in the UAE & Middle East</h3>
                    <p>Discover how our Shopify expertise can help you build, scale, and optimize your online store for success.</p>
                    <a href="" class="contactus btn btn-primary d-block ">Contact us</a>
                </div>
            </div>
            
        </div>
    </div>
</section> -->
<section class="foot-shopfiy-banner">
    <div class="container">
        <div>
            <div class="row align-items-center">
                <div class="col-sm-3">
                    <div class="logo-shopify-foot">
                        <img src="assets/img/shopify/shopifyfooterlogo.png"/>
                    </div>
                </div>
                <div class="col-sm-9">
                    <div class="logo-shopify-foot-cards">
                        <div class="shopify-cards">
                            <h3>Your Trusted Shopify Partner in Middle East</h3>
                            <p>Discover how our Shopify expertise can help you build, scale, and optimize your online store for success.</p>
                            <a href="" class="contactus btn btn-primary d-block ">Contact us</a>
                        </div>
                        <img src="assets/img/shopify/blurshopify.png"/>
                    </div>
                </div>
            </div>
        </div>
       
    </div>
</section>